export default "__VITE_ASSET__CJVeO0pB__"